export const initialEstablishmentInterfaceValues: IEstablishmentInterfaceForm ={
  establishmentID: 0,
  unitType: "",
  unitID: "",
  nodeID: "",
  interfaceID: "",
  selectedField: ""
}

export const initialEstablishmentUnitForm: IEstablishmentUnitForm = {
  unitType: "",
  unitID: ""
};

export const initialEstablishmentNodeForm: IEstablishmentNodeForm = {
  nodeID: "",
};



